export const EVENT_TYPE_OPTIONS = [
  { value: "boda", label: "Boda" },
  { value: "xv", label: "XV Años" },
  { value: "bautizo", label: "Bautizo" },
  { value: "sesion", label: "Sesión de Fotos" },
  { value: "foto_video", label: "Foto + Video" },
  { value: "boda_civil", label: "Boda Civil" },
  { value: "save_the_date", label: "Save the Date" },
  { value: "eventos_sociales", label: "Eventos Sociales" },
];

export const eventTypeLabel = (value) =>
  EVENT_TYPE_OPTIONS.find((o) => o.value === value)?.label || value;

export const toDateKey = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};
